<template>
  <el-dialog
    :title="pathNodeDialog.type === 'edit' ? '编辑排序' : '添加知识点'"
    :visible.sync="pathNodeDialog.visible"
    width="600px"
    @close="pathNodeDialogClose"
    @open="getListKnowledgeWithChapter"
  >
    <el-form :model="pathNodeDialog.form" label-width="120px" :rules="pathNodeRules" ref="pathNodeFormRef">
      <el-form-item label="学习路径">
        {{ pathNodeDialog.form.path_name }}
      </el-form-item>
      <el-form-item label="知识点" prop="knowledgeId">
        <el-cascader
          :options="newChapterListData"
          :props="cascaderProps"
          v-model="pathNodeDialog.form.knowledgeId"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          :disabled="pathNodeDialog.type === 'edit'"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item label="排序" prop="orderIndex">
        <el-input-number v-model="pathNodeDialog.form.orderIndex" :min="0" :max="999" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="pathNodeDialogClose">取消</el-button>
      <el-button type="primary" @click="pathNodeSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { studyPathKnowledgeSave, knowledgeWithChapter } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KgPathNodeDialog',
  inject: ['pathNodeDialog', 'getHypergraphstudypathNodeData', 'courseId'],
  data() {
    return {
      newChapterListData: [],
      cascaderProps: {
        emitPath: false,
        label: 'name',
        value: 'id',
      },
      pathNodeRules: {
        knowledgeId: [{ required: true, message: '请选择知识点', trigger: 'change' }],
        orderIndex: [{ required: true, message: '请输入排序', trigger: 'change' }],
      },
    }
  },
  methods: {
    getListKnowledgeWithChapter() {
      knowledgeWithChapter({ courseId: this.courseId.value }).then(res => {
        if (res.code == 0 && res.data) {
          this.newChapterListData = this.transformStructure(res.data)
        }
      })
    },
    transformStructure(data) {
      // 构建三级结构：章 → 节 → 知识点
      return (data || []).map(function (chapter) {
        var chapterNode = {
          id: 'chapter_' + chapter.id,
          name: chapter.name,
          children: [],
        }
        var sections = chapter.chapters || chapter.children || []
        sections.forEach(function (section) {
          var sectionNode = {
            id: 'section_' + section.id,
            name: section.name,
            children: [],
          }
          var knowledges = section.knowledges || []
          knowledges.forEach(function (k) {
            sectionNode.children.push({ id: k.id, name: k.name })
          })
          if (sectionNode.children.length) {
            chapterNode.children.push(sectionNode)
          }
        })
        var chapterKnowledges = chapter.knowledges || []
        chapterKnowledges.forEach(function (k) {
          chapterNode.children.push({ id: k.id, name: k.name })
        })
        return chapterNode
      })
    },
    pathNodeDialogClose() {
      this.pathNodeDialog.visible = false
      this.pathNodeDialog.type = 'add'
      this.pathNodeDialog.form = { orderIndex: 0, knowledgeId: '', studyPathId: '', path_name: '', path_id: '' }
    },
    pathNodeSubmit() {
      this.$refs.pathNodeFormRef.validate(valid => {
        if (valid) {
          var form = this.pathNodeDialog.form
          var params = {
            orderIndex: form.orderIndex,
            knowledgeId: form.knowledgeId,
            studyPathId: form.path_id,
          }
          if (form.id) params.id = form.id
          console.log('[KgPathNode] submit params:', JSON.stringify(params))
          studyPathKnowledgeSave(params).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.pathNodeDialogClose()
            this.getHypergraphstudypathNodeData()
          })
        }
      })
    },
  },
}
</script>
